import React from "react";
import Header from "../../components/Header/Header";
import GalleriesCard from "../../components/Main/GalleriesCard";
import Footer from "../../components/Footer/Footer";

import { getWpGallerypage, getSomeGalleries } from "../../data/galleries";

export default function Galleries(props) {
  const {
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId,
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,
  } = props.page.gallery.acf;

  const { galleries: galleriesPosts } = props.page;

  return (
    <React.Fragment>
      <Header
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug="/galleries"
      />
      <main id="content" className="events-page">
        <div className="stories">
          <GalleriesCard galleriesPosts={galleriesPosts} page={props.page} />
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export async function getStaticProps({ preview = false }) {
  const page = {
    gallery: await getWpGallerypage(),
    galleries: await getSomeGalleries(),
  };

  return {
    props: {
      page,
    },
  };
}
